const oa = [
    {
        path: 'functionalAppraise',
        name: 'functionalAppraise',
        component: () => import ('@/views/OA/ScoreManage/functionalAppraiseStep1.vue'), // 我的绩效
        meta: {
            title: 'functionalProcess'
        }
    },
    {
        path: 'functionalAppraiseAppeal',
        name: 'functionalAppraiseAppeal',
        component: () => import ('@/views/OA/ScoreManage/functionalAppraiseStepAppeal.vue'), // 我的绩效
        meta: {
            title: 'functionalAppeal'
        }
    },
    {
        path: 'functionalAppraiseHr',
        name: 'functionalAppraiseHr',
        component: () => import ('@/views/OA/ScoreManage/functionalAppraiseStepHr.vue'), // 我的绩效
        meta: {
            title: 'functionalProcess'
        }
    },
    {
        path: 'functionalAppraiseAppealHr',
        name: 'functionalAppraiseAppealHr',
        component: () => import ('@/views/OA/ScoreManage/functionalAppraiseAppealHr.vue'), // 我的绩效
        meta: {
            title: 'functionalAppeal'
        }
    },
    {   path: 'appraiserConfirmKPI',
        name: 'appraiserConfirmKPI',
        component: () => import ('@/views/OA/TargetConfirmation/appraiserConfirmKPI.vue'), // 第一/第二考核人-职能KPI方案制定和确认流程
        meta: {
            title: 'functionalTarget'
        }
    },
    {
        path: 'appraiserConfirmSTI',
        name: 'appraiserConfirmSTI',
        component: () => import ('@/views/OA/TargetConfirmation/appraiserConfirmSTI.vue'), // 第一/第二考核人-职能STI方案制定和确认流程
        meta: {
            title: 'functionalTarget'
        }
    },
    {
        path: 'appraiserConfirmKPIAndSTI',
        name: 'appraiserConfirmKPIAndSTI',
        component: () => import ('@/views/OA/TargetConfirmation/appraiserConfirmKPIAndSTI.vue'), // 第一/第二考核人-职能KPI+STI方案制定和确认流程
        meta: {
            title: 'functionalTarget'
        }
    },
    {
        path: 'HRConfirmKPI',
        name: 'HRConfirmKPI',
        component: () => import ('@/views/OA/TargetConfirmation/HRConfirmKPI.vue'), // HR-职能KPI方案制定和确认流程
        meta: {
            title: 'functionalTarget'
        }
    },
    {
        path: 'HRConfirmSTI',
        name: 'HRConfirmSTI',
        component: () => import ('@/views/OA/TargetConfirmation/HRConfirmSTI.vue'), // HR-职能STI方案制定和确认流程
        meta: {
            title: 'functionalTarget'
        }
    },
    {
        path: 'HRConfirmKPIAndSTI',
        name: 'HRConfirmKPIAndSTI',
        component: () => import ('@/views/OA/TargetConfirmation/HRConfirmKPIAndSTI.vue'), // HR-职能KPI+STI方案制定和确认流程
        meta: {
            title: 'functionalTarget'
        }
    },
    {
        path: 'appraiserModifyKPI',
        name: 'appraiserModifyKPI',
        component: () => import ('@/views/OA/TargetModification/appraiserModifyKPI.vue'), // 第一/第二考核人-职能KPI方案修正流程
        meta: {
            title: 'functionalTarget'
        }
    },
    {
        path: 'appraiserModifySTI',
        name: 'appraiserModifySTI',
        component: () => import ('@/views/OA/TargetModification/appraiserModifySTI.vue'), // 第一/第二考核人-职能STI方案修正流程
        meta: {
            title: 'functionalTarget'
        }
    },
    {
        path: 'appraiserModifyKPIAndSTI',
        name: 'appraiserModifyKPIAndSTI',
        component: () => import ('@/views/OA/TargetModification/appraiserModifyKPIAndSTI.vue'), // 第一/第二考核人-职能KPI+STI方案修正流程
        meta: {
            title: 'functionalTarget'
        }
    },
    {
        path: 'HRModifyKPI',
        name: 'HRModifyKPI',
        component: () => import ('@/views/OA/TargetModification/HRModifyKPI.vue'), // HR-职能KPI方案修正流程
        meta: {
            title: 'functionalTarget'
        }
    },
    {
        path: 'HRModifySTI',
        name: 'HRModifySTI',
        component: () => import ('@/views/OA/TargetModification/HRModifySTI.vue'), // HR-职能STI方案修正流程
        meta: {
            title: 'functionalTarget'
        }
    },
    {
        path: 'HRModifyKPIAndSTI',
        name: 'HRModifyKPIAndSTI',
        component: () => import ('@/views/OA/TargetModification/HRModifyKPIAndSTI.vue'), // HR-职能KPI+STI方案修正流程
        meta: {
            title: 'functionalTarget'
        }
    },
    {
        path: 'salesResultAppeal',
        name: 'salesResultAppeal',
        component: () => import ('@/views/OA/SalesCategory/salesResultAppeal.vue'), // 销售KPI结果申诉流程
        meta: {
            title: 'appealDetails'
        }
    },
]

export default oa;